import { FC, useCallback } from "react";
import styles from "./index.module.scss";

///////////////////// interface ///////////////////////

interface IProps {
  point: number
}

///////////////////// Function ///////////////////////

const Point: FC<IProps> = ({ point }) => {

  const pointColorHandler = useCallback((currentPoint: number): string => {
    if (currentPoint <= 5) return "#00A049"
    else if (currentPoint <= 3) return "#65AA57"
    else if (currentPoint <= 2) return "#B1B64D"
    else return "#F9BC00"
  }, [point])

  return (
    <div
      className={styles.point}
      style={{
        backgroundColor: pointColorHandler(point)
      }}
    >
      <p>{point ? point.toFixed(1) : 0}</p>
    </div>
  );
};

export default Point;
